<template>
  <v-footer class="font-weight-medium" inset padless app v-if="false">
    <v-col class="text-center" cols="12">
      © 2020 - PassDelivery.Web - Privacy
    </v-col>
  </v-footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    color: {
      type: String,
      default: "#fff",
    },
  },
  mounted() {
    window.VERSION = process.env.VERSION || "0";
  },
};
</script>

<style lang="scss" scoped>
.v-footer {
  font-size: 0.75rem;
}
</style>